module.exports = __webpack_public_path__ + "assets/16311f0ee442437bb959f292712d518c.mp3";